import { delay } from "rambda"

import type { PanelProps } from "../panel-props"

import { useSelectSettings } from "../../../hooks/use-select-settings.ts"
import { useToggleSettings } from "../../../hooks/use-toggle-settings.ts"
import { useSettings } from "../../../modules/settings.ts"
import { Select } from "../../select.tsx"
import { ToggleButton } from "../../toggle-button.tsx"
import { toast } from "../../ui/toast.tsx"
import { SharedSettings } from "../shared-settings.tsx"

const LANGUAGE_OPTIONS = {
  bulgarian: "bulgarian",
  finnish: "finnish",
  french: "french",
  german: "german",
  greek: "greek",
  italian: "italian",
  portuguese: "portuguese",
  spanish: "spanish",
}

export function SelectCorrectTranslationSettings(input: PanelProps) {
  const { appSettings, setAppSettings } = useSettings()
  const { isOn: autoListenOn, toggle: toggleAutoListen } = useToggleSettings({
    currentValue: appSettings.shared.autoListen,
    setValue: newValue=> {
      setAppSettings("autoListen", newValue, "shared")
    },
  })
  const { isOn: speakWhenHandsFreeOn, toggle: toggleSpeakWhenHandsFree } =
    useToggleSettings({
      currentValue: appSettings.shared.speakWhenHandsFree,
      setValue: newValue=> {
        setAppSettings("speakWhenHandsFree", newValue, "shared")
      },
    })
  const {
    onChange: handleSelectLanguageChange,
    options: selectLanguageOptions,
  } = useSelectSettings({
    options: LANGUAGE_OPTIONS,
    setValue: newValue=> {
      setAppSettings("speakAppLanguage", newValue, "shared")
      toast.success(
        "Language changed successfully | Window will reload to apply changes",
      )
      delay(1000).then(()=> {
        window.location.reload()
      })
    },
  })
  return (
    <SharedSettings closeSidebar={input.closeSidebar}>
      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Listening</h3>
        <ToggleButton
          checked={autoListenOn}
          label="Auto-listen"
          onChange={toggleAutoListen}
        />
        <ToggleButton
          checked={speakWhenHandsFreeOn}
          label="Automatic speak"
          onChange={toggleSpeakWhenHandsFree}
        />
      </section>

      <div className="sidebar__separator" role="separator" />

      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Language</h3>
        <Select
          initialValue={appSettings.shared.speakAppLanguage}
          label={"Selected language"}
          onChange={handleSelectLanguageChange}
          options={selectLanguageOptions}
        />
      </section>
    </SharedSettings>
  )
}
